import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export const useApiSearchAdminTakenunit = (args) => {
    return useQuery({
        queryKey: ['admin', 'takenunit', 'search', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/takenunits`, {params: config});
        })(args)),
    })
}
